import React from "react";
import "./skeleton.css";

const SkeletonBox = ({
  width = "100%",
  height = 12,
  className = "",
  style = {},
  borderRadius = 8,
}: {
  width?: string | number;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
  borderRadius?: number | string;
}) => {
  const resolvedWidth = typeof width === "number" ? `${width}px` : width;
  const resolvedHeight = typeof height === "number" ? `${height}px` : height;

  return (
    <div
      className={`skeleton-wave-block skeleton-light ${className}`.trim()}
      style={{
        width: resolvedWidth,
        height: resolvedHeight,
        borderRadius,
        ...style,
      }}
    />
  );
};

export default SkeletonBox;
